import { handleError } from "../../components/Utils/Utils"
import ApiService from "../ApiService"

export default class ReconciliationService {
    static storeReconciliation = async (params) => {
        try {
            const instance = await ApiService();
            return instance.post(`/reconciliation`, params)
        } catch (error) {
            handleError(error)
        }
    }

    static storeReconciliationTransaction = async (params) => {
        try {
            const instance = await ApiService();
            return instance.post(`/reconciliation/transaction`, params)
        } catch (error) {
            handleError(error)
        }
    }

    static getReconciliationList = async (params) => {
        let date_start, date_end, num, cursor;
    
        if (params.date_start && params.date_start !== "") {
          date_start = `&date_start=${params.date_start}`;
        }
    
        if (params.date_end && params.date_end !== "") {
          date_end = `&date_end=${params.date_end}`;
        }
    
        if (params.num && params.num !== "") {
          num = `?num=${params.num}`;
        } else {
          num = `?num=20`;
        }
    
        if (params.cursor && params.cursor !== "") {
          cursor = `&cursor=${params.cursor}`;
        }
    
        const instance = await ApiService();
        return instance.get(
          `/reconciliation${num}${date_start || ""}${
            date_end || ""
          }${cursor || ""}`
        );
      };

    static getSummaryReconciliation = async () => {
      const instance = await ApiService();
      return instance.get(`/reconciliation/summary`);
    }

    static getFailedReconciliation = async () => {
      const instance = await ApiService();
      return instance.get(`/reconciliation/failed`);
    }

    static getDetailReconciliation = async (id) => {
        const instance = await ApiService();
        return instance.get(`/reconciliation/${id}`);
    }

    static downloadReconcialitionTransaction = async (id) => {
      const instance = await ApiService();
      return instance.get(`/reconciliation/download/${id}`);
  }

    static patchReconciliationTransactionSettled = async (id, params) => {
      const instance = await ApiService();
      return instance.patch(`/reconciliation/transaction/settled/${id}`, params);
    };
}